import { Stack, Box, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { icons } from "assets/AssetHelper";
import React from "react";

export default function PaymentDetails({ details }) {
  const { t } = useTranslation();
  const currency = details?.cart?.currency?.name;
  const deliverFees = details?.cart?.delivery_fees;
  const itemsNum = details?.cart?.cart_items?.length;
  const giftCardPrice = details?.cart?.gift_card?.card?.price_after_discount;
  const vat = details?.cart?.vat_amount;
  const vatPercentage = details?.cart?.vat;
  const amountWithVat = details?.cart?.amount_with_vat;
  const promoDiscountAmount = details?.cart?.promo_discount_amount;
  const total =
    amountWithVat -
    ((+giftCardPrice || 0) +
      +(vat || 0) +
      +(deliverFees || 0) +
      +(promoDiscountAmount || 0));
  const totalAfterVat = details?.cart?.amount_with_vat;
  const paymentInfo = {
    [`${t("orders.subtotal")} ( ${itemsNum} ${t("orders.items")} )`]: total,
    [t("orders.label_gift_card")]: giftCardPrice,
    [`${t("orders.label_vat")}( ${vatPercentage} % )`]: vat,
    [t("orders.col_delivery_fees")]: deliverFees,
    [t("orders.label_promo_discount")]: promoDiscountAmount,
    [t("orders.col_total")]: totalAfterVat,
  };

  const cardStyle = {
    width: { xs: "100%", md: "47%" },
    backgroundColor: "white",
    p: 3,
    gap: 3,
    borderRadius: "8px",
  };

  return (
    <Stack sx={cardStyle}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={{ xs: 1.5, sm: 0 }}
      >
        {/* ----------- CARD HEADER ----------- */}
        <Stack direction="row" alignItems="center" gap={2}>
          <Box component="img" width="46px" src={icons.fees} />
          <Typography fontWeight="500" fontSize={{ xs: "18px", sm: "24px" }}>
            {t("orders.col_payment_method")}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center">
          <Typography
            sx={{
              px: 2,
              py: 1,
              fontSize: { xs: "14px", sm: "18px" },
              backgroundColor: "#F2F2F2",
              borderRadius: "6px",
              fontWeight: "500",
            }}
          >
            {details?.payment_method?.name}
          </Typography>
        </Stack>
      </Stack>
      <Stack gap={1}>
        {Object.keys(paymentInfo).map((key, i) => (
          <React.Fragment key={i}>
            <Stack direction="row" justifyContent="space-between" gap={1.5}>
              <Typography
                sx={{
                  width: { xs: "60%", sm: "40%", md: "25%" },
                  color: "#969696",
                  fontSize: { xs: "13px", sm: "16px" },
                }}
              >
                {key}
              </Typography>
              <Typography
                sx={{
                  width: { xs: "35%", sm: "55%", md: "70%" },
                  textAlign: "right",
                  fontSize: { xs: "14px", sm: "16px" },
                }}
              >
                {paymentInfo[key]} {paymentInfo[key] ? currency : "-"}
              </Typography>
            </Stack>
            {i == Object.keys(paymentInfo).length - 2 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </Stack>
  );
}
